import Model from "./base/model";

class CteReadingEmail extends Model{
  resourceName() {
    return "cte_reading_emails";
  }

  fields() {
    return {
      email: "",
      transporter_cte_reading_emails: { jsonApi: "hasMany", type: "transporter_cte_reading_emails" },
    };
  }

}

export default new CteReadingEmail();
